import React, { useContext } from "react";
import userphoto from "../../../images/user.png";
import { Dropdown } from "react-bootstrap";
import LogoutPopup from "../LogoutPopup";
import { Link } from "react-router-dom";
import { UserContext } from "../../../App";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../../apolloClient";
import { VIEW_ROLE } from "../../../query/ViewRole";

const UserProfile = () => {
  const { userContextState } = useContext(UserContext);

  const [modalShow, setModalShow] = React.useState(false);
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  return (
    <Dropdown className="header-userprofile">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        <span className="icon">
          <img src={userphoto} alt="admin" />
        </span>
        <p> {userContextState?.user_name} </p>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div className="userprofile-header">
          <div className="icon">
            <img src={userphoto} alt="admin" />
          </div>
          <div className="user-info">
            <p className="user-name">{userContextState?.user_name}</p>
            <p className="user-role-name">{userRole?.users[0].role==="business"?"Business":"Club"}</p>
          </div>
        </div>
        {userRole?.users[0].role==="business"? <Link to="/business-profile">
          <span className="user-list-cover">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.2692 5.73333C12.2692 6.95327 11.2668 7.96667 10 7.96667C8.73318 7.96667 7.73077 6.95327 7.73077 5.73333C7.73077 4.5134 8.73318 3.5 10 3.5C11.2668 3.5 12.2692 4.5134 12.2692 5.73333ZM13.7692 5.73333C13.7692 7.7952 12.0817 9.46667 10 9.46667C7.91832 9.46667 6.23077 7.7952 6.23077 5.73333C6.23077 3.67147 7.91832 2 10 2C12.0817 2 13.7692 3.67147 13.7692 5.73333ZM8.46342 12.0333H11.5366C13.6689 12.0333 15.5 13.851 15.5 16.2222C15.5 16.3188 15.4636 16.3929 15.4181 16.4403C15.3735 16.4867 15.33 16.5 15.2927 16.5H4.70732C4.67003 16.5 4.62647 16.4867 4.58194 16.4403C4.5364 16.3929 4.5 16.3188 4.5 16.2222C4.5 13.851 6.33108 12.0333 8.46342 12.0333ZM3 16.2222C3 13.0803 5.44606 10.5333 8.46342 10.5333H11.5366C14.5539 10.5333 17 13.0803 17 16.2222C17 17.2041 16.2356 18 15.2927 18H4.70732C3.76439 18 3 17.2041 3 16.2222Z"
                fill="#989DB2"
              />
            </svg>
            My Profile
          </span>
        </Link> : 
        <Link to="/club-profile">
        <span className="user-list-cover">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.2692 5.73333C12.2692 6.95327 11.2668 7.96667 10 7.96667C8.73318 7.96667 7.73077 6.95327 7.73077 5.73333C7.73077 4.5134 8.73318 3.5 10 3.5C11.2668 3.5 12.2692 4.5134 12.2692 5.73333ZM13.7692 5.73333C13.7692 7.7952 12.0817 9.46667 10 9.46667C7.91832 9.46667 6.23077 7.7952 6.23077 5.73333C6.23077 3.67147 7.91832 2 10 2C12.0817 2 13.7692 3.67147 13.7692 5.73333ZM8.46342 12.0333H11.5366C13.6689 12.0333 15.5 13.851 15.5 16.2222C15.5 16.3188 15.4636 16.3929 15.4181 16.4403C15.3735 16.4867 15.33 16.5 15.2927 16.5H4.70732C4.67003 16.5 4.62647 16.4867 4.58194 16.4403C4.5364 16.3929 4.5 16.3188 4.5 16.2222C4.5 13.851 6.33108 12.0333 8.46342 12.0333ZM3 16.2222C3 13.0803 5.44606 10.5333 8.46342 10.5333H11.5366C14.5539 10.5333 17 13.0803 17 16.2222C17 17.2041 16.2356 18 15.2927 18H4.70732C3.76439 18 3 17.2041 3 16.2222Z"
              fill="#989DB2"
            />
          </svg>
          My Profile
        </span>
      </Link>}
        

        <Link to="/settings">
          <span className="user-list-cover">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.30924 6.77161C1.57234 7.98318 2.27635 9.23475 3.12525 9.69965L3.29948 9.79476C3.29681 9.86409 3.29503 9.93343 3.29414 10.0001C3.29503 10.0668 3.29681 10.1361 3.29948 10.2054L3.12525 10.3005C2.27635 10.7654 1.57234 12.017 2.30924 13.2286L3.29325 14.8446C3.98126 15.9744 5.32172 16.0251 6.14129 15.5762L6.29951 15.489C6.49685 15.6171 6.70218 15.7362 6.91196 15.8464V15.8766C6.91196 16.9628 7.76975 18.0002 9.01599 18.0002H10.984C12.2302 18.0002 13.088 16.9628 13.088 15.8766V15.8464C13.2978 15.7362 13.5032 15.6171 13.7005 15.489L13.8587 15.5762C14.6783 16.0251 16.0187 15.9744 16.7067 14.8446L17.6908 13.2286C18.4277 12.017 17.7236 10.7654 16.8747 10.3005L16.7005 10.2054C16.7032 10.1361 16.705 10.0668 16.7059 10.0001C16.705 9.93343 16.7032 9.86409 16.7005 9.79476L16.8747 9.69965C17.7236 9.23475 18.4277 7.98318 17.6908 6.77161L16.7067 5.15559C16.0187 4.0258 14.6783 3.97602 13.8587 4.42403L13.7005 4.51114C13.5032 4.38314 13.2978 4.26403 13.088 4.1538V4.12358C13.088 3.03735 12.2302 2 10.984 2H9.01599C7.76975 2 6.91196 3.03735 6.91196 4.12358V4.1538C6.70218 4.26403 6.49685 4.38314 6.29951 4.51114L6.14129 4.42403C5.32172 3.97602 3.98126 4.0258 3.29325 5.15559L2.30924 6.77161ZM6.46396 6.62761L5.28972 5.98405C5.1155 5.88894 4.90038 5.9316 4.80972 6.08094L3.8257 7.69696C3.73504 7.84629 3.80259 8.04363 3.97682 8.13963L5.21772 8.81875C5.12172 9.19653 5.07016 9.59298 5.07016 10.0001C5.07016 10.4072 5.12172 10.8037 5.21772 11.1814L3.97682 11.8606C3.80259 11.9566 3.73504 12.1539 3.8257 12.3032L4.80972 13.9193C4.90038 14.0686 5.1155 14.1113 5.28972 14.0161L6.46396 13.3726C7.06663 13.9815 7.8302 14.4348 8.68798 14.6668V15.8766C8.68798 16.0677 8.83465 16.2224 9.01599 16.2224H10.984C11.1653 16.2224 11.312 16.0677 11.312 15.8766V14.6668C12.1698 14.4348 12.9334 13.9815 13.536 13.3726L14.7103 14.0161C14.8845 14.1113 15.0996 14.0686 15.1903 13.9193L16.1743 12.3032C16.265 12.1539 16.1974 11.9566 16.0232 11.8606L14.7823 11.1814C14.8783 10.8037 14.9298 10.4072 14.9298 10.0001C14.9298 9.59298 14.8783 9.19653 14.7823 8.81875L16.0232 8.13963C16.1974 8.04363 16.265 7.84629 16.1743 7.69696L15.1903 6.08094C15.0996 5.9316 14.8845 5.88894 14.7103 5.98405L13.536 6.62761C12.9334 6.01871 12.1698 5.56538 11.312 5.33426V4.12358C11.312 3.93247 11.1653 3.7778 10.984 3.7778H9.01599C8.83465 3.7778 8.68798 3.93247 8.68798 4.12358V5.33426C7.8302 5.56538 7.06663 6.01871 6.46396 6.62761ZM9.99654 12.6668C11.4677 12.6668 12.6597 11.473 12.6597 10.0001C12.6597 8.52719 11.4677 7.3334 9.99654 7.3334C8.52541 7.3334 7.3334 8.52719 7.3334 10.0001C7.3334 11.473 8.52541 12.6668 9.99654 12.6668ZM11 10C11 10.552 10.5526 11 10 11C9.44745 11 9 10.552 9 10C9 9.448 9.44745 9 10 9C10.5526 9 11 9.448 11 10Z"
                fill="#3F434A"
              />
            </svg>
            Settings
          </span>
        </Link>
        <Link to="#/action-3" className="user-logout">
          <span className="user-list-cover">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.36111 3.5C4.13273 3.5 3.9137 3.59072 3.75221 3.75221C3.59072 3.9137 3.5 4.13273 3.5 4.36111V15.6389C3.5 15.8673 3.59072 16.0863 3.75221 16.2478C3.9137 16.4093 4.13273 16.5 4.36111 16.5H7.58333C7.99755 16.5 8.33333 16.8358 8.33333 17.25C8.33333 17.6642 7.99755 18 7.58333 18H4.36111C3.73491 18 3.13435 17.7512 2.69155 17.3084C2.24876 16.8657 2 16.2651 2 15.6389V4.36111C2 3.73491 2.24876 3.13435 2.69155 2.69155C3.13435 2.24876 3.73491 2 4.36111 2H7.58333C7.99755 2 8.33333 2.33579 8.33333 2.75C8.33333 3.16421 7.99755 3.5 7.58333 3.5H4.36111ZM12.6919 5.4419C12.9848 5.14901 13.4597 5.14901 13.7526 5.4419L17.7803 9.46968C17.8597 9.54903 17.9175 9.64175 17.9539 9.74058C17.9765 9.80199 17.9914 9.86718 17.9972 9.93494C18.0065 10.042 17.9928 10.1507 17.9562 10.253C17.9201 10.3542 17.8614 10.4493 17.7803 10.5303L13.7526 14.5581C13.4597 14.851 12.9848 14.851 12.6919 14.5581C12.399 14.2652 12.399 13.7903 12.6919 13.4975L15.4394 10.75H7.58331C7.1691 10.75 6.83331 10.4142 6.83331 10C6.83331 9.58579 7.1691 9.25 7.58331 9.25H15.4393L12.6919 6.50256C12.399 6.20967 12.399 5.73479 12.6919 5.4419Z"
                fill="#8A9099"
              />
            </svg>
            <span onClick={() => setModalShow(true)}>Logout</span>
            <LogoutPopup show={modalShow} onHide={() => setModalShow(false)} />
          </span>
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default UserProfile;
